"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _v13PagesRouter = require("../v13-pagesRouter");
Object.keys(_v13PagesRouter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _v13PagesRouter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _v13PagesRouter[key];
    }
  });
});